import { render, staticRenderFns } from "./DokoTricksOverview.vue?vue&type=template&id=25bb4f10&scoped=true&"
import script from "./DokoTricksOverview.vue?vue&type=script&lang=ts&"
export * from "./DokoTricksOverview.vue?vue&type=script&lang=ts&"
import style0 from "./DokoTricksOverview.vue?vue&type=style&index=0&id=25bb4f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bb4f10",
  null
  
)

export default component.exports